import { render, staticRenderFns } from "./WaiverSigned.vue?vue&type=template&id=197b4e60&"
import script from "./WaiverSigned.vue?vue&type=script&lang=js&"
export * from "./WaiverSigned.vue?vue&type=script&lang=js&"
import style0 from "./WaiverSigned.vue?vue&type=style&index=0&id=197b4e60&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports